/*emTheme.js*-------------------*/
(function($) {
  var $body,
    $nav,
    $a,
    largeur,
    allwebsite,
    emTheme = {
      init: function() {
        /*$("body").imagesLoaded({}, function() {
        });*/
      },
      animImg: function($anim){
        $anim.each(function(i){
          var delay = 0.2;
          if (i % 2 === 0) {
            delay = 0;
          }
          $current = $(this);
          $x = $current.width();
          $img = $current.find('img');
          $an = $current.find('.anim-element');
          var tl = new TimelineLite();
          tl
            .add("first")
            .add("middle", "+=0.8")
            .add("end", "+=0.8")
            .to($an, 0.8, { x: 0 }, "first")
            .set($img, {visibility:"visible"},"middle")
            .to($an, 0.8, { x: $x }, "middle")
            .delay(delay);
          new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook : 0.8,
                reverse : false,
              })
              .setTween(tl)
              .addTo(allWebsite);

        });
      },
      animBlock: function($anim){
        $anim.each(function(i){
          var delay = 0.2;
          if (i % 2 === 0) {
            delay = 0;
          }
          $current = $(this);
          var tlb = TweenLite.fromTo($current, 0.6, {y:30, opacity:0},{y:0,opacity:1,delay:delay});
          new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook : 0.8,
                reverse : false,
              })
              .setTween(tlb)
              .addTo(allWebsite);
        });
      }
    };

  $(window).resize(function() {});

  $(document).ready(function() {
    emTheme.init();
    $body = $("body");
    $a = $("#primary");
    allWebsite =  new ScrollMagic.Controller();
    width = $(window).width();
    $timer = $('.timer');
    reload = false;
    if ($a.hasClass("accueil")) {
      $("h1").html(function(index, html) {
        return html.replace(/\S/g, '<span>$&</span>');
      });
      $sl = $('.slide-main');
      $(".slide-main").bxSlider({
        mode: "fade",
        pager: false,
        controls: false,
        auto: true,
        speed: 1000,
        pause: 6000,
        onSliderLoad : function(){
          TweenLite.set($('#home1'), {visibility:"visible"});
          var tl = new TimelineLite();
          tl.staggerFromTo($('h1').find('span'), 0.5, {opacity:0},{opacity:1}, 0.05);
          TweenLite.fromTo($timer, 6, {x:-width, y:0, z:0},{x:0, y:0, z:0,delay:0,ease:Linear.easeNone});
        },
        onSlideBefore : function($el, oldIndex, newIndex){
          var tl = new TimelineLite();
          tl
            .add("first")
            .add("middle", "+=0.7")
            .to($('.anim-element'), 0, { x: -width }, "first")
            .to($('.anim-element'), 0.5, { x: 0 }, "first")
            .to($('.anim-element'), 0.5, { x: width }, "middle");
          TweenLite.fromTo($timer, 6, {x:-width, y:0, z:0},{x:0, y:0, z:0,delay:0,ease:Linear.easeNone});
          if ($el.hasClass('home-else')) {
            $art = $el.find('article');
            $cont = $el.find('.container');
            TweenLite.fromTo($art, 0.6, {opacity:0},{opacity:1,delay:2.5});
            TweenLite.fromTo($cont, 0.2, {x:0, y:-30, z:0, opacity:0},{x:0, y:0, z:0, opacity:1,delay:3.1});
          }
        }
      });
    }
    else if ($a.hasClass('presentation')) {
      $title = $('h1');
      $article = $('.type-page');

      TweenLite.fromTo($title, 0.5, {x:0, y:40, z:0, opacity:0},{x:0, y:0, z:0, opacity:1,delay:0.5});
      TweenLite.fromTo($article, 0.2, {x:500, y:0, z:0, opacity:0},{x:0, y:0, z:0, opacity:1,delay:1});
      $anim = $('.bloc-anim');
      if ($anim.length){
        emTheme.animBlock($anim);
      }
    }
    else if ($a.hasClass('archive-actu')) {
      $title = $('h1');
      TweenLite.fromTo($title, 0.5, {x:0, y:40, z:0, opacity:0},{x:0, y:0, z:0, opacity:1,delay:0.5});
      $anim = $('.bloc-anim');
      if ($anim.length){
        emTheme.animBlock($anim);
      }
    }
    else if ($a.hasClass('single-actu')) {
      $title = $('h1');
      $ctg = $('.ctg');
      $content = $('.entry-content');
      TweenLite.set($title, {visibility:"visible"});
      TweenLite.set($ctg, {visibility:"visible"});
      TweenLite.set($content, {visibility:"visible"});
      TweenLite.fromTo($ctg, 0.5, {x:60, y:0, z:0, opacity:0},{x:0, y:0, z:0, opacity:1,delay:0.2});
      TweenLite.fromTo($title, 0.5, {x:60, y:0, z:0, opacity:0},{x:0, y:0, z:0, opacity:1,delay:0.5});
      TweenLite.fromTo($content, 0.5, {x:60, y:0, z:0, opacity:0},{x:0, y:0, z:0, opacity:1,delay:0.8});
    }
    else if ($a.hasClass('single-real')) {

      $liste = $("#liste-masonry");
      if ($liste.length) {
        $liste.imagesLoaded(function() {
          $liste.masonry({
            itemSelector: ".item-masonry",
            columnWidth: ".item-masonry",
            gutter: ".gutter-sizer",
            transitionDuration: 0
          });
          $container = $('.container-texte');
          $principal = $('.contenu-principal');
          TweenLite.set($container, {visibility:"visible"});
          TweenLite.set($principal, {visibility:"visible"});

          TweenLite.fromTo($('.bloc-titre'), 0.6, {x:500, y:0, z:0, opacity:0},{x:0, y:0, z:0, opacity:1,delay:0.5});
          TweenLite.fromTo($('.ville'), 0.2, {x:500, y:0, z:0, opacity:0},{x:0, y:0, z:0, opacity:1,delay:1});
          TweenLite.fromTo($('.entry-title'), 0.2, {x:500, y:0, z:0, opacity:0},{x:0, y:0, z:0, opacity:1,delay:1.2});
          TweenLite.fromTo($('.departement'), 0.2, {x:0, y:30, z:0, opacity:0},{x:0, y:0, z:0, opacity:1,delay:1});
          TweenLite.fromTo($('.bloc-jaune'), 0.2, {x:40, y:0, z:0, opacity:0},{x:0, y:0, z:0, opacity:1,delay:1.6});
          $anim = $('.item-masonry');
          if ($anim.length){
            emTheme.animImg($anim);
          }
        });
      }
    }
    else if ($a.hasClass('archive-real')) {
      $mainImg = $('.banniere').find('img');
      $title = $('.banniere').find('.entry-title');
      TweenLite.set($mainImg, {visibility:"visible"});
      TweenLite.set($title, {visibility:"visible"});
      TweenLite.fromTo($mainImg, 1, {x:-100, y:0, z:0, opacity:0},{x:0, y:0, z:0, opacity:1,delay:0.7});
      TweenLite.fromTo($title, 1, {x:100, y:0, z:0, opacity:0},{x:0, y:0, z:0, opacity:1,delay:1.3});
      $anim = $('.container-real').find('article');
      if ($anim.length){
        emTheme.animImg($anim);
      }
    }

    $open = $("#menu-responsive");
    $open.click(function(e) {
      e.preventDefault();
      $open.toggleClass("is-active");
      $body.toggleClass("menu-open");
    });

    $(".action-scroll").click(function(e) {
      e.preventDefault();
      anchor = $(this).attr("href");
      $("html, body").animate(
        { scrollTop: parseInt($(anchor).offset().top) - 100 },
        1000
      );
    });

  });
})(jQuery);
